import { FC, useEffect, useState } from 'react';
import Dialog from 'Components/Dialog';
import StampCardConfirm from './StampCardConfirm';
import { gql, useMutation } from '@apollo/client';
import { useSelector } from 'Hooks';

const MARK_STAMP_SEEN = gql`
  mutation markStampSeen($id: ID!) {
    updateStamp(id: $id, seen: true) {
      id
      seen
    }
  }
`;

const MarkSeenDialog: FC = () => {
  const [markStampSeen] = useMutation(MARK_STAMP_SEEN);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const stampCards = useSelector((state) => state.userStampCards);
  const stamps = useSelector((state) => state.userStamps);

  // Find a stamp card that has collected enough unseen stamps to unlock its offer.
  const completedCard = stampCards.find((card) => {
    if (!card.offer) {
      return false;
    }
    const cardStamps = stamps.filter((stamp) => stamp.stampCard.id === card.id);
    return cardStamps.length >= card.count;
  });

  const cardStamps = completedCard
    ? stamps.filter((stamp) => stamp.stampCard.id === completedCard.id)
    : [];
  const offerImage = completedCard?.offer?.image?.file?.url ?? '';

  useEffect(() => {
    if (showDialog) {
      return;
    }
    if (completedCard) {
      setShowDialog(true);
    }
  }, [completedCard?.id]);

  const onConfirm = () => {
    cardStamps.forEach((stamp) => {
      markStampSeen({
        variables: {
          id: stamp.id,
        },
      });
    });

    setShowDialog(false);
  };

  return (
    <Dialog visible={showDialog} onClose={() => {}}>
      <StampCardConfirm onClose={onConfirm} offerImage={offerImage} />
    </Dialog>
  );
};

export default MarkSeenDialog;
